import _objectSpread from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _objectWithoutProperties from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
var _excluded = ["language"];
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import { defineComponent, ref } from "vue"; // modules

import CommonModule from "@/store/modules/common";
import UserModule from "@/store/modules/user";
import CustomersModule from "@/store/modules/customers";
import AppModule from "@/store/modules/app"; // helpers

import { dialogVisibleForStatus, hideDialog } from "@/utils/vue-helpers/modal";
import { convertIdToCodeLang } from "@/utils/helpers/lang";
import NotificationService from "@/services/notification.service"; // constants

import { ModalStatus } from "@/constants/modal";
import { useI18n } from "vue-i18n";
import BookingModule from "@/store/modules/booking";
export default defineComponent({
  name: "CustomerCreate",
  components: {},
  setup: function setup() {
    var modalVisibility = dialogVisibleForStatus(ModalStatus.CustomerCreate);
    var isLoading = ref(false);
    var customerCreateForm = ref();
    var maxHeight = "50vh";

    var _useI18n = useI18n({}),
        t = _useI18n.t;

    CommonModule.fetchCountries({
      lang: AppModule.language
    });

    var onSave = function onSave(isSelect) {
      if (!customerCreateForm.value) return;
      isLoading.value = true;
      customerCreateForm.value.form.validate( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(valid) {
          var _customerCreateForm$v, language, data, params, newCustomer, country, city, email, firstName, lastName, phone, id, company, address, allergies, _language, title, zipCode, emailMarketingOrganiser, birthDate;

          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!valid) {
                    _context.next = 15;
                    break;
                  }

                  _customerCreateForm$v = customerCreateForm.value.ruleForm, language = _customerCreateForm$v.language, data = _objectWithoutProperties(_customerCreateForm$v, _excluded);
                  params = _objectSpread(_objectSpread({
                    groupId: UserModule.getUserGroupId
                  }, data), {}, {
                    language: convertIdToCodeLang(language)
                  });
                  _context.next = 5;
                  return CustomersModule.postCustomer(params);

                case 5:
                  newCustomer = _context.sent;

                  if (!(isSelect && newCustomer)) {
                    _context.next = 10;
                    break;
                  }

                  country = newCustomer.country, city = newCustomer.city, email = newCustomer.email, firstName = newCustomer.firstName, lastName = newCustomer.lastName, phone = newCustomer.phone, id = newCustomer.id, company = newCustomer.company, address = newCustomer.address, allergies = newCustomer.allergies, _language = newCustomer.language, title = newCustomer.title, zipCode = newCustomer.zipCode, emailMarketingOrganiser = newCustomer.emailMarketingOrganiser, birthDate = newCustomer.birthDate; // TODO: Only one customer per booking for now

                  _context.next = 10;
                  return CustomersModule.setSelectedCustomers([{
                    country: country,
                    city: city,
                    email: email,
                    fullName: "".concat(firstName, " ").concat(lastName),
                    phone: phone,
                    id: String(id),
                    checkOrder: true,
                    bookingUuid: BookingModule.selectedBookingUUID,
                    company: company,
                    address: address,
                    allergies: allergies,
                    language: _language,
                    title: title,
                    zipCode: zipCode,
                    emailMarketingOrganiser: emailMarketingOrganiser,
                    birthDate: birthDate
                  }]);

                case 10:
                  CustomersModule.getCustomersList.push(newCustomer);
                  isLoading.value = false;
                  hideDialog();
                  _context.next = 17;
                  break;

                case 15:
                  isLoading.value = false;
                  NotificationService.showCustomMessage(t("error.missing-fields"), "warning");

                case 17:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    };

    return {
      modalVisibility: modalVisibility,
      isLoading: isLoading,
      customerCreateForm: customerCreateForm,
      maxHeight: maxHeight,
      hideDialog: hideDialog,
      onSave: onSave,
      t: t
    };
  }
});